import { useMutation } from '@tanstack/react-query'
import type { UploadProps } from 'antd'
import type { RcFile } from 'antd/es/upload'
import axios from 'axios'

import { supportTicketsUploadsCreateMutation } from 'src/api/main'

export type TicketAttachmentResponse = {
  id: number
}

export const useTicketAttachmentUpload = () => {
  const { mutateAsync: createUpload } = useMutation({
    ...supportTicketsUploadsCreateMutation()
  })

  const customRequest: NonNullable<UploadProps['customRequest']> = async ({
    file,
    onProgress,
    onSuccess,
    onError
  }) => {
    const attachment = file as RcFile
    const contentType = attachment.type || 'application/octet-stream'

    try {
      const upload = await createUpload({
        body: { title: attachment.name, content_type: contentType }
      })

      await axios.put(upload.upload_url, attachment, {
        headers: { 'Content-Type': contentType },
        onUploadProgress: ({ loaded, total }) => {
          if (!total) return

          onProgress?.({ percent: Math.round((loaded / total) * 100) })
        }
      })

      onSuccess?.({ id: upload.id } satisfies TicketAttachmentResponse)
    } catch (error) {
      onError?.(error as Error)
    }
  }

  return customRequest
}
